import React from 'react';
import V1RememberedAccountsPage from './V1Page';
import V2RememberedAccountsPage from './V2Page';

type RememberedAccountsPageProps = {
  loginStateSource?: 'v1' | 'v2';
};

const RememberedAccountsPage = ({ loginStateSource = 'v1' }: RememberedAccountsPageProps) => {
  return loginStateSource === 'v2' ? <V2RememberedAccountsPage /> : <V1RememberedAccountsPage />;
};

export default RememberedAccountsPage;
